<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Contact Info"
    size="sm"
    @on-hide="resetFormData"
  >
    <contact-info-form
      v-bind="value"
      @on-submit="update"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import ContactInfoForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ContactInfoEditModal',
  mixins: [formModalMixin],
  components: {
    ContactInfoForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: `contact-info-${this.value.id}-edit-modal`,
    };
  },
  methods: {
    update(data, handleUpdate) {
      handleUpdate(this.$contactInfosAPI.update(this.value.id, data));
    },
    onSave(contactInfo) {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save', contactInfo);
    },
  },
};
</script>
